import { emptyFragment } from '@execonline-inc/execonline-ui';
import { NotTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { L, T } from '../../../../../../Translations';
import { LicenseInsight, ProductLicenseOverview } from '../../../Types';
import LicenseInsightMessage from './LicenseInsightMessage';

interface Props {
  insightIndex: number;
  licenseInsight: LicenseInsight;
}

function LicenseAlert({ insightIndex, licenseInsight }: Props) {
  const labelFor = (licenseOverview: ProductLicenseOverview, index: number) => {
    const targetId = `products-insights-${insightIndex}-license-${index}-label`;
    return licenseOverview.publicName
      .map((publicName) => (
        <span
          className="font-light text-sm bg-[#187a90] text-white px-2 py-1 mx-2 rounded-sm"
          data-intercom-target={targetId}
        >
          <NotTranslated text={publicName} />
        </span>
      ))
      .getOrElse(emptyFragment);
  };

  return (
    <div className="mb-2 rounded-md bg-white px-6 py-4 drop-shadow-md last:mb-0 relative">
      <div className="text-lg font-medium">
        <LicenseInsightMessage licenseInsight={licenseInsight} />
      </div>
      {licenseInsight.productLicenseOverviews.toArray().map((licenseOverview, index) => (
        <div key={licenseOverview.id}>
          <NotTranslated text={licenseOverview.name} />
          {labelFor(licenseOverview, index)}
          &nbsp; (
          <T
            kind="Expires <date/>"
            date={<L localizeable={licenseOverview.endOn} format={'short-month-day-year'} />}
          />
          )
        </div>
      ))}
    </div>
  );
}

export default observer(LicenseAlert);
